import * as TYPES from './type';
export default {
  //授课举手
  [TYPES.SK_INTERACT_LIST](state, { result }) {
    state.SKInteractList = result.result
  },
  //举手添加
  [TYPES.SK_INTERACT_ADD](state, { result }) {
    state.SKInteractAdd = result.result
  },
  //举手查询
  [TYPES.SK_INTERACT_QUERY](state, { result }) {
    state.SKInteractQuery = result.result
  },
  //举手结束
  [TYPES.SK_INTERACT_OVER](state, { result }) {
    state.SKInteractOver = result.result
  },
  //举手结果
  [TYPES.SK_INTERACT_RES](state, { result }) {
    state.SKInteractRes = result.result
  },
  //举手编辑
  [TYPES.SK_INTERACT_EDIT](state, { result }) {
    state.SKInteractEdit = result.result
  },
}
